import Vue from 'vue';
import Vuetify, {VIcon} from 'vuetify/lib';

// Vue.use(Vuetify);
Vue.use(Vuetify,{components:{VIcon}})


export default new Vuetify({
    theme: {
        themes: {
          light: {
            primary: "#51c7fd",
            secondary: "#f59cd3", // #FFCDD2
            accent: '#3F51B5', // #3F51B5
          },
        },
      },    
});
